import tw from "twin.macro"

export const Wrapper = tw.div`
  flex-1 w-full pb-2 pt-1
`
